// Module
var code = " <input class=\"form-control\" type=\"text\" readonly=\"readonly\" ng-model=\"model[options.key]\"/> ";
// Exports
export default code;